/* 

exemple dans un button: 
v-loading="{ loading: loading, id: 'myloading' tag: 'span', target: 'div.loadingspace' size: 'sm'}"

puis: 
data(){ return {loading : true}; }
 */

const loaderHTML = (size) => {
  return `<div class="spinner-border spinner-border-${size}" role="status">
      <span class="visually-hidden">Loading...</span>
  </div>`;
}

export default {
  bind: (el, binding) => {
    let spinner = document.createElement(binding.value.tag || 'div');
    if (binding.value.id) spinner.id = binding.value.id;
    spinner.classList.add("clirLoader", "p-1", "m-0", "d-flex", "position-absolute", "align-content-center", "justify-content-center", "flex-grow", "flex-wrap");

    spinner.style.width = "100%";
    spinner.style.height = "100%";
    spinner.style.inset = "0"
    spinner.style.zIndex = "1";
    spinner.style.cursor = "wait";
    spinner.style.backgroundColor = "#ccccccaa";
    spinner.innerHTML = loaderHTML(binding.value.size || "");

    if (binding.value.target) {
      el.querySelector(binding.value.target).prepend(spinner);
    } else {
      el.prepend(spinner);
    }
  },
  inserted: (el, binding) => {
    const spinner = el.querySelector(".clirLoader");
    if (binding.value.loading) {
      spinner.style.display = "";
    } else {
      spinner.style.setProperty("display", "none", "important");
    }

  },
  update: (el, binding) => {
    const spinner = el.querySelector(".clirLoader");
    if (binding.value.loading) {
      spinner.style.display = "";
    } else {
      spinner.style.setProperty("display", "none", "important");
    }

  }
};